/* 
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved. 
* Distributed under the TruVideo proprietary license. 
*/
import apiClient from '../api/client';

export const subAccountService = {
  // GET /api/accounts/all/sub-accounts (all sub-accounts)
  // GET /api/accounts/:accountId/sub-accounts (account-specific)
  getSubAccounts: (accountId, params) => {
    const id = accountId || 'all';
    return apiClient.get(`/accounts/${id}/sub-accounts`, { params });
  },

  // GET /api/accounts/:accountId/sub-accounts/:subId
  getSubAccountById: (accountId, subId) =>
    apiClient.get(`/accounts/${accountId}/sub-accounts/${subId}`),

  // POST /api/accounts/:accountId/sub-accounts
  createSubAccount: (accountId, data) =>
    apiClient.post(`/accounts/${accountId}/sub-accounts`, data),

  // GET /api/accounts/:accountId/sub-accounts/:subId/clone-options
  getCloneOptions: (accountId, subId) =>
    apiClient.get(`/accounts/${accountId}/sub-accounts/${subId}/clone-options`),

  // POST /api/accounts/sub-accounts/clone
  cloneSubAccount: (data) =>
    apiClient.post('/accounts/sub-accounts/clone', data),

  // PATCH /api/accounts/:accountId/sub-accounts/:subId
  updateSubAccount: (accountId, subId, data) =>
    apiClient.patch(`/accounts/${accountId}/sub-accounts/${subId}`, data),

  // DELETE /api/accounts/:accountId/sub-accounts/:subId
  deleteSubAccount: (accountId, subId) =>
    apiClient.delete(`/accounts/${accountId}/sub-accounts/${subId}`),

  // POST /api/accounts/upload-logo?subAccountId=<id>
  // type defaults to 'logo' (10 MB); use 'favicon' to apply 5 MB server-side check.
  // Requires sub_accounts.update — for account/platform admins only.
  uploadLogo: (file, subAccountId = null, type = 'logo') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    const url = subAccountId
      ? `/accounts/upload-logo?subAccountId=${encodeURIComponent(subAccountId)}`
      : '/accounts/upload-logo';
    return apiClient.post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  // POST /api/accounts/upload-workflow-logo
  // Requires templates.create — accessible to sub-account users. The upload
  // tenant is always the caller's own sub-account, resolved server-side.
  uploadWorkflowLogo: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post('/accounts/upload-workflow-logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
